import * as React from 'react'
import { PaymentScheduleItemModel } from '../../../Model/PaymentScheduleItemModel'
import { observer, inject } from 'mobx-react'
import LocalizationStore from '../../../Stores/LocalizationStore'
import DateTimeHelper from '../../../Helpers/DateTimeHelper'
import { Col } from 'react-bootstrap'
import * as _ from 'lodash'
import { getPaymentScheduleSum } from '../../../Helpers/PaymentScheduleHelper'

export interface IPaymentScheduleViewProps {
    prepaymentSum: number
    scheduleArr: Array<PaymentScheduleItemModel>
    localizationStore?: LocalizationStore
    className?: string
}

@inject('localizationStore')
@observer
export default class PaymentScheduleView extends React.Component<IPaymentScheduleViewProps> {
    render() {
        const { scheduleArr, localizationStore, className, prepaymentSum } = this.props

        if (!scheduleArr || !scheduleArr.length || prepaymentSum == null) {
            return (
                <div className="rjsf paymentsSchedule">
                    <legend id="root__title">{localizationStore!.t('paymentsScheduleJson')}</legend>
                    <p className="warning">{localizationStore!.t('Payments schedule parse error')}</p>
                </div>
            )
        }

        return (
            <div className={className} hidden={!scheduleArr}>
                <div className="container p-0">
                    <div className="row">
                        <p>{localizationStore!.t('paymentsScheduleJson')}</p>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {localizationStore!.t('prepaymentSum')}:&nbsp;
                            {prepaymentSum}&nbsp;AZN
                     </div>
                    </div>

                    <div className="row paymentsSchedule">
                        <ul className="col-12">
                            {
                                _.orderBy(scheduleArr, ['date'], ['asc'])
                                    // .sort((p1, p2) => {
                                    //     return new Date(p1.date).getTime() - new Date(p2.date).getTime()
                                    // })
                                    .map(function (item: PaymentScheduleItemModel, i: number) {
                                        return (
                                            <li role="presentation" className="item" key={i}>
                                                <Col xs={6} sm={6} md={6} lg={6}>
                                                    <span className="date">
                                                        {DateTimeHelper.formatDateForList(item.date.toString())}:
                                                    </span>&nbsp;
                                                </Col>
                                                <Col xs={6} sm={6} md={6} lg={6} className="text-right">
                                                    <span className="sum">{item.sum}&nbsp;AZN</span>
                                                </Col>
                                            </li>
                                        )
                                    })
                            }
                        </ul>
                    </div>

                    <div className="row">
                        <div className="col-6 offset-6 text-right">
                            <div>
                                <span>{localizationStore!.t('sum')} </span>
                                <mark>{getPaymentScheduleSum(scheduleArr)!.toFixed(2)}</mark>
                            </div>
                            <div>
                                <span>{localizationStore!.t('totalSum')} </span>
                                <mark>{
                                    (getPaymentScheduleSum(scheduleArr) + Number(prepaymentSum))
                                        .toFixed(2)}
                                </mark>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/PaymentSchedule/PaymentScheduleView.tsx